module.exports = __webpack_public_path__ + "static/media/linkedin-login-logo.e4228369.png";